//单位列表
const unitOption = [{
    label: '个'
  },
  {
    label: '包'
  },
  {
    label: '箱'
  },
  {
    label: '只'
  },
  {
    label: '支'
  },
  {
    label: '份'
  },
  {
    label: '套'
  },
  {
    label: '盒'
  },
  {
    label: '斤'
  },
  {
    label: '克'
  },
  {
    label: '千克'
  }
]
// 状态
const stateOption = [{
    label: '正常'
  },
  {
    label: '停购'
  },
  {
    label: '停售'
  },
  {
    label: '删除'
  },
  {
    label: '停用'
  }
]
//商品属性
const proWayOption = [{
    label: '普通商品'
  },
  {
    label: '组合商品'
  },
]
//提成方式
const tcWayOption = [{
    label: '按金额'
  },
  {
    label: '按比例'
  },
  {
    label: '按毛利'
  },
]
//计价方式
const priceWayOption = [{
    label: '普通'
  },
  {
    label: '计重'
  },
  {
    label: '计数'
  }
]
// 通用
const ynOption = [{
    label: '是'
  },
  {
    label: '否'
  },
]

export default {
  unitOption,
  stateOption,
  proWayOption,
  tcWayOption,
  priceWayOption,
  ynOption,

}



// WEBPACK FOOTER //
// ./src/assets/js/globalOption.js